
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Spinner } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Spinner`}</h1>
<p>{`Used to show any sort of loading on the page, or on a specific part of the page.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Spinner } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Spinner />`} component={Spinner} mdxType="Playground">
  <Spinner mdxType="Spinner" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;